
export class OccurenceType {
    id: number;
    name: string;
    checked?: boolean;
    disabled?: boolean;
    messageDisable?: string;

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

}